import RavelloService from '@/services/ravello'

export const APIKeys = {
	name: 'API keys',
	route: 'api-keys',
}

export const APIKey = {
	name: 'New key',
	route: 'api-key',
	params: ['key'],
	lazyName: {
		fn: async key => (key === 'generate' ? null
			: RavelloService.get(`/v1/apikeys/${key}`)),
		params: ['key'],
		field: 'name',
	},
}

export const APIRoles = {
	name: 'API Roles',
	route: 'api-roles',
}

export const APIRole = {
	name: 'New API role',
	route: 'api-role',
	params: ['role'],
	lazyName: {
		fn: async role => (role === 'new' ? null
			: RavelloService.get(`/v1/roles/${role}`)),
		params: ['role'],
		field: 'name',
	},
}

export const FeatureFlags = {
	name: 'Feature Flags',
	route: 'feature-flags',
}

export const Notifications = {
	name: 'Notifications',
	route: 'notifications',
}

export const NotificationSubscribers = {
	name: 'Subscribers',
	route: 'subscribers',
	params: ['group'],
	lazyName: {
		fn: async group => RavelloService.get(`/v1/notifications/groups/${group}`),
		params: ['group'],
		field: 'name',
	},
}

export const NotificationSubscriber = {
	name: 'New subscriber',
	route: 'subscriber',
	params: ['subscriber'],
	lazyName: {
		fn: async subscriber => (subscriber === 'new' ? null
			: RavelloService.get(`/v1/notifications/subscribers/${subscriber}`)),
		params: ['subscriber'],
		field: 'name',
	},
}

export const Roles = {
	name: 'Roles',
	route: 'roles',
}

export const Role = {
	name: 'New role',
	route: 'role',
	params: ['role'],
	lazyName: {
		fn: async role => (role === 'new' ? null
			: RavelloService.get(`/v3/roles/${role}`)),
		params: ['role'],
		field: 'name',
	},
}

export const Sessions = {
	name: 'Sessions',
	route: 'sessions',
}

export const Users = {
	name: 'Users',
	route: 'users',
}

export const User = {
	name: 'New user',
	route: 'user',
	params: ['user'],
	lazyName: {
		fn: async user => (user === 'new' ? null
			: RavelloService.get(`/v1/users/${user}`)),
		params: ['user'],
		field: 'email',
	},
}
